<div [ngClass]="{'bg-light': !listItem}" class="card plan-card container-fluid p-3">
  <div class="row">
    <div class="col-12 col-md-8">
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="row mb-3">
            <div class="col-12 font-weight-normal mb-1">{{pcpInfo.name}}</div>
            <div class="col-12">{{translationPrefix + '.providerId' | translate}}: {{pcpInfo.hfProviderId}}</div>
          </div>
          <div class="row mb-3">
            <div class="col-12">{{pcpInfo.address}}</div>
          </div>
          <div class="row mb-3 mb-md-0">
            <div class="col-12">{{pcpInfo.phone}}</div>
          </div>
        </div>
        <div class="col-12 col-md-5">
          <div class="row mb-3">
            <div class="col-auto col-md-12 mb-1">{{translationPrefix + '.acceptingNewPatients' | translate}}?</div>
            <div class="col-auto col-md-12 pl-0 pl-md-3 font-weight-normal">
              {{'common.formFieldsValues.defaultRadio.' + (pcpInfo.acceptNewPatients ? 'yes' : 'no') | translate}}
            </div>
          </div>
          @if (pcpInfo.distance !== undefined) {
          <div class="row mb-3 mb-md-0">
            <div class="col-auto col-md-12 mb-1">{{translationPrefix + '.distanceFromZip' | translate}}:</div>
            <div class="col-auto col-md-12 pl-0 pl-md-3 font-weight-normal">
              <span>{{translationPrefix + '.miles' | translate: {x: pcpInfo.distance | number:'1.2-2'} }}</span>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
    <div class="col-12 col-md-4 align-self-center text-center text-md-right">
      @if (listItem) {
      <button (click)="emitItemSelected()" class="btn btn-block btn-outline-success text-capitalize bg-white px-5">
        {{translationPrefix + '.selectPcp' | translate}}
      </button>
      } @if (!listItem) {
      <button (click)="emitItemRemoved()" class="btn btn-block btn-outline-success text-capitalize bg-white px-5">
        {{translationPrefix + '.removePcp' | translate}}
      </button>
      }
    </div>
  </div>
</div>
